import React from 'react';
import WhatsAppCTA from './WhatsAppCTA';

interface DiffItem {
  icon: string;
  text: string;
}

interface SectionDifferentialsProps {
  title: string;
  items: DiffItem[];
  cta?: { text: string; message: string };
}

const SectionDifferentials: React.FC<SectionDifferentialsProps> = ({ title, items, cta }) => (
  <section className="lp-section lp-section--differentials" aria-labelledby="diff-title">
    <div className="lp-container">
      <h2 id="diff-title">{title}</h2>
      <ul className="lp-list lp-list--diff">
        {items.map((item, i) => (
          <li key={i}>
            <i className={item.icon} aria-hidden="true" />
            <span>{item.text}</span>
          </li>
        ))}
      </ul>
      {cta && (
        <div className="lp-section-cta">
          <WhatsAppCTA message={cta.message} id="cta-differentials">
            {cta.text}
          </WhatsAppCTA>
        </div>
      )}
    </div>
  </section>
);

export default SectionDifferentials;
